import React, { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axiosInstance from "../../../utils/axiosInstance";
import moment from "moment";
const CreditDebitPopupDetails = () => {
  const { transid } = useParams();

  const [remark, setRemark] = useState("");
  const [amount, setAmount] = useState(0);
  const [createdDate, setCreatedDate] = useState(0);
  const [uname, setUname] = useState(0);

  useEffect(() => {
    const fetchBetDetails = async () => {
      const response = await axiosInstance.get(
        `profit-loss/trans-details/${transid}`
      );
      setCreatedDate(response?.data.bet?.created_date);
      setRemark(response?.data.bet?.remark);
      setAmount(response?.data.bet?.amount);
      setUname(response?.data.bet?.uname);
    };
    fetchBetDetails();
  }, []);

  return (
    <div>
      <div class="row ledger">
        <div class="col-12">
          <div class="card">
            <div class="card-header">
              <h3>{remark}</h3>
            </div>
            <div class="card-body">
              <table class="table table-hover">
                <tbody>
                  <tr>
                    <td>UserName</td>
                    <td>
                      <strong>{uname}</strong>
                    </td>
                  </tr>
                  <tr>
                    <td>Date</td>
                    <td>
                      <span class="market-time">
                        {moment(createdDate).format("MM/DD/YYYY HH:mm:ss a")}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td class="col-sm-3">Amount</td>
                    <td class="col-sm-9">
                      <strong>{amount}</strong>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>{" "}
        </div>
      </div>
      <style>{`
  body {
    background:white
  }

`}</style>
    </div>
  );
};

export default CreditDebitPopupDetails;
